import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { bindActionCreators } from 'redux';

import beGetTimeOffAllowancesForStylist from 'actions/timeoff/beGetTimeOffAllowancesForStylist.action';
import IMG_ARROW_TOGGLE from 'assets/images/time-off-panel/arrow-toggle.svg';
import SvgIcon from 'components/generic/SvgIcon.component';
import StylistAllowancesTable from 'components/timeoff/StylistAllowancesTable.component';
import useTip from 'hooks/useTip.hook';
import { useTranslation } from 'providers/GILT.provider';
import { withTheme } from 'providers/Theme.provider';
import { selectTimeOffCategories, selectTimeOffReport } from 'selectors/timeoff.selectors';
import asObject from 'utils/objects/asObject.util';

import CN from './StylistAllowancesDrawer.module.scss';

const StylistAllowancesDrawer = ({ isDarkMode, stylist, headers, report, isHoursSelected }) => {
  const { val: isOpen, tip: toggleDrawer } = useTip(false);
  const { t } = useTranslation();

  const { id: stylistId, is_self_employed: isSelf, role, user_name: userName } = asObject(stylist);
  const { name: roleName } = asObject(role);

  const selfEmployedText = t('staffKpisReports.reportsTimeOff.selfEmployedStatus');
  const employedText = t('staffKpisReports.reportsTimeOff.employedStatus');

  const displayStylist = `${userName} - ${roleName}- ${isSelf ? selfEmployedText : employedText}`;
  const stylistData = asObject(report)[stylistId];

  return (
    <div
      data-bem="StylistAllowancesDrawer"
      className={cn({
        [CN.component]: true,
        [CN.selected]: isOpen,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.toggleButton}>
        <div data-bem="StylistAllowancesDrawer__header" className={CN.header} role="button" tabIndex={0} onClick={toggleDrawer}>
          {displayStylist}
          <div className={CN.arrow}>
            <SvgIcon alt="arrow toggle" icon={IMG_ARROW_TOGGLE} size="sm" />
          </div>
        </div>
        {isOpen && (
          <div>
            <StylistAllowancesTable headers={headers} value={stylistData} isHoursSelected={isHoursSelected} />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  categories: selectTimeOffCategories(state),
  report: selectTimeOffReport(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ beGetTimeOffAllowancesForStylist }, dispatch);

const StylistAllowancesDrawerHoc = connect(mapStateToProps, mapDispatchToProps)(withTheme()(StylistAllowancesDrawer));

export default StylistAllowancesDrawerHoc;
